import { render } from "./PedidoFinal.vue?vue&type=template&id=65db7ac6&scoped=true"
import script from "./PedidoFinal.vue?vue&type=script&lang=js"
export * from "./PedidoFinal.vue?vue&type=script&lang=js"

import "./PedidoFinal.vue?vue&type=style&index=0&id=65db7ac6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65db7ac6"]])

export default __exports__